import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../../../NotFound'

import { AbilityContext } from '../../../../components/Ability'
import { useUser } from '../../../../hooks/useUser'
import ShippingSettingsListPage from './Features/ShippingSettingsList'

const ShippingSettingsPage = () => {
  const ability = useContext(AbilityContext)
  const { user, loading } = useUser()
  const canAccess =
    ability.can('manage', 'Setting', 'shipping') ||
    !!user?.isEnableShippingSettings
  return (
    <Routes>
      <Route
        path="/"
        element={
          loading ? null : canAccess ? (
            <ShippingSettingsListPage />
          ) : (
            <NotFound />
          )
        }
      />
    </Routes>
  )
}

export default ShippingSettingsPage
